var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loggedIn)?_c('div',{staticClass:"home"},[_c('Home',{attrs:{"msg":'Release ' + _vm.version,"invited":_vm.showSignUp}})],1):_c('div',{attrs:{"c":"","lass":"home"}},[_c('ListSharesView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }